import { useTranslation } from "react-i18next";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../../../components/styledComponents/Result";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function SchlankheitDesErsatzstabes({ lambda = 0 }) {
  const { t } = useTranslation("translation");

  const gamma_quer_Formula = `\\displaystyle \\overline{\\lambda} = \\sqrt{\\frac{A_{s} \\cdot f_{yk}}{\\overline{N}_{ki}}} \\ge 0,2`;
  const LAMBDA_CHECKVALUE = 0.2;

  function isValid() {
    if (!lambda) return false;
    return Number(lambda) >= LAMBDA_CHECKVALUE;
  }

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.slendernessEquivalentBar")}</p>}
      indicesValue={<span style={{ textDecoration: "overline" }}>&lambda;</span>}
      formulaValue={
        <ToolTip id={"gamma_quer_Formula"} type={IconType.FORMULA} formula={gamma_quer_Formula} />
      }
      inputValue={
        <ResultSpan valid={isValid()}>
          <NumberFormatText value={lambda} decimalScale={2} />
        </ResultSpan>
      }
    />
  );
}

export default SchlankheitDesErsatzstabes;
